import React from 'react'
import { Col, Row, Skeleton } from 'antd-v4'
import { Link } from 'react-router'
import Title from 'antd-v4/lib/typography/Title'
import Paragraph from 'antd-v4/lib/typography/Paragraph'

export interface IDashboardImageCardProps {
  title: string
  introduction?: string
  items: string[]
  buttonUrl: string
  buttonText: string
  imageUrl?: string
  isExternalUrl?: boolean
  isHidden?: boolean
  isLoading?: boolean
}

const ImageCardSkeleton = () => {
  return (
    <div className='card shadow-lg  mb-4 p-4'>
      <Skeleton active />
    </div>
  )
}

const ImageCard = ({
  title,
  introduction,
  buttonUrl,
  buttonText,
  imageUrl,
  isExternalUrl,
  items,
  isLoading,
}: IDashboardImageCardProps) => {
  const introText = introduction ?? 'Introducing'
  const linkProps = isExternalUrl
    ? { to: { pathname: buttonUrl }, target: '_blank' }
    : { to: buttonUrl }
  return isLoading ? (
    <ImageCardSkeleton />
  ) : (
    <article className='card shadow-lg  mb-4 p-4'>
      <Row justify='space-between' className='mb-2'>
        <Col span={12}>
          <Paragraph strong>{introText}</Paragraph>
        </Col>
        <Col span={12}>
          <Link
            style={{ textAlign: 'right', textDecoration: 'underline', float: 'right' }}
            {...linkProps}
          >
            {buttonText}
          </Link>
        </Col>
      </Row>
      <Row>
        <Col span={20}>
          <Title level={2} style={{ fontSize: '20px' }}>
            {title}
          </Title>
          <ul className='mt-2 text-muted' style={{ paddingLeft: '25px' }}>
            {items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </Col>
        <Col span={4}>
          <img src={imageUrl} alt='img' style={{ width: 56, float: 'right' }} />
        </Col>
      </Row>
    </article>
  )
}

export const DashboardImageCard = ({ isHidden, ...props }: IDashboardImageCardProps) =>
  isHidden ? null : <ImageCard {...props} />
